import InputGroup from "../../../../components/FormComponent/InputGroup";
import Layout from "../../../../components/Layout";
import BreadCrumb from "../../../../components/BreadCrumb";
import { useState, useEffect } from "react";
import { httprequest } from "../../../../data/api";
import { toast } from "react-toastify";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import { StructureType } from "../../../../utils/DropDown";
import Select from "react-select";
import Flutterwave from "../../../../assets/images/flutterwave.jpeg";
import PayStack from "../../../../assets/images/paystack.jpeg";
import PayPal from "../../../../assets/images/paypal.jpeg";
import Stripe from "../../../../assets/images/stripe.png";
import Remita from "../../../../assets/images/remita.png";
import TextAreaGroup from "../../../../components/FormComponent/TextAreaGroup";
import Button from "../../../../components/Button";
import useStyles from "../../styles";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper,
  Grid
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import useValidator from "../../../../hooks/useValidator";
import Modal from "../../../../components/Modal";
import { useUserState } from "../../../../context/UserContext";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const ALL_STUDENT = "/api/v1/students";
const ADMIN_CLASS_ENDPOINT = "/api/v1/class";
const CLASS_SUBJECT = "/api/v1/class-subject/";
const SCH_ITEM = "/api/v1/fee-item";
const SCH_INTEGRATION = "/api/v1/integrations/school";
const INTEGRATIONS = "/api/v1/integrations";
const INVOICE_ENDPOINT = "/api/v1/invoices";
const SCHOOL_DISCOUNTS = "/api/v1/discounts";

const CreateInvoice = () => {
  const { profile } = useUserState();
  const [activeSession, setActiveSession] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [structureType, setStructureType] = useState([]);
  const [allstudent, setAllStudent] = useState([]);
  const [invoiceItem, setInvoiceItem] = useState([]);
  const [classData, setClassData] = useState([]);
  const [paymentIntegration, setPaymentIntegration] = useState([]);
  const [invoiceValidator, showInvoiceValidator] = useValidator();
  const [isGettingCurrency, setIsgettingCurrency] = useState(false);
  const [discountModal, setDiscountModal] = useState(false);
  const [isGettingDiscounts, setIsGettingDiscounts] = useState(false);
  const [discountItems, setDiscountItems] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isSending, setisSending] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const classes = useStyles();
  const [currency, setCurrency] = useState([]);
  const navigate = useNavigate();
  const [rows, setRows] = useState([
    { item_id: "", amount: "" }
  ]);

  /**
 * Main invoice form state
 * @state
 * @type {InvoiceForm}
 */
  const [invoiceForm, setCreateInvoiceForm] = useState({
    invoice_name: "",
    structure_type: "",
    // class_id: [],
    term_id: "",
    // subject_id: "",
    // student_id: "",
    invoice_items: rows,
    // payment_method: [],
    due_date: "",
    description: "",
    total: ""
  });
  /**
 * Closes the cancel confirmation modal
 * @function handleCloseCancelModal
 */
  const handleCloseCancelModal = () => {
    setCancelModal(false);
  };

  /**
 * Today's date in YYYY-MM-DD format
 * @constant
 * @type {string}
 */
  const today = new Date();
  const formattedToday = `${today.getFullYear()}-${
    String(today.getMonth() + 1).padStart(2, "0")}-${
    String(today.getDate()).padStart(2, "0")}`;

  /**
 * Toggles the cancel confirmation modal
 * @function handleCancelModal
 */
  const handleCancelModal = () => {
    setCancelModal(!cancelModal);
  };

  const handleBankAccountChange = (event, bankId) => {
    const isChecked = event.target.checked;

    setCreateInvoiceForm((prevForm) => {
      const currentBankAccounts = new Set(prevForm.bank_accounts || []);

      if (isChecked) {
        currentBankAccounts.add(bankId);
      } else {
        currentBankAccounts.delete(bankId);
      }

      return {
        ...prevForm,
        bank_accounts: Array.from(currentBankAccounts)
      };
    });
  };

  const handleDiscountModal = () => {
    setDiscountModal(!discountModal);
  };

  /**
   * Fetches all invoice items from the server.
   * @function
   * @description Makes a GET request to SCHOOL_DISCOUNTS endpoint and updates the invoice items state.
   */
  const getAllDiscounts = () => {
    setIsGettingDiscounts(true);
    httprequest
      .get(SCHOOL_DISCOUNTS)
      .then((res) => {
        setDiscountItems(res?.data?.data);
        setIsGettingDiscounts(false);
      }).catch((err) => {
        setIsGettingDiscounts(true);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Calculates and updates the total invoice amount
 * @effect
 * @listens rows
 */
  useEffect(() => {
    const updatedRows = rows.map((row) => ({
      ...row,
      amount: parseFloat(row?.amount) || 0
    }));

    const totalAmount = updatedRows.reduce((sum, row) => sum + row.amount, 0);

    setCreateInvoiceForm((prevForm) => ({
      ...prevForm,
      total: totalAmount // Store numeric total
    }));
  }, [rows]); // Runs only when `rows` change

  /**
 * Formats the total amount with commas
 * @function getFormattedTotal
 * @returns {string} Formatted total amount
 */
  const getFormattedTotal = () => {
    const total = invoiceForm?.total || 0;
    const discountPercentage = selectedDiscount?.value || 0;

    // Calculate discounted amount
    const discountAmount = total * (discountPercentage / 100);
    const discountedTotal = total - discountAmount;

    return new Intl.NumberFormat("en-US").format(discountedTotal);
  };

  /**
 * Handles sending the invoice
 * @function handleSendInvoice
 * @async
 */
  const handleSendInvoice = () => {
    setisSending(true);

    if (invoiceValidator.allValid()) {
      setisSending(true);
      httprequest
        .post(INVOICE_ENDPOINT, { ...invoiceForm, status: "sent" })
        .then((res) => {
          setisSending(false);
          setTimeout(() => {
            navigate("/payment/invoice");
          }, 1500);
          toast.success(res?.data?.message || "Invoice Sent Successfully");
        })
        .catch((err) => {
          setisSending(false);
          toast.error(err?.response?.data?.message || "An error occurred");
        });
    } else {
      setisSending(false);
      showInvoiceValidator(true);
    }
  };

  /**
 * Handles saving the invoice as draft
 * @function handleSaveInvoice
 * @async
 */
  const handleSaveInvoice = () => {
    setIsSaving(true);

    if (invoiceValidator.allValid()) {
      setIsSaving(true);
      httprequest
        .post(INVOICE_ENDPOINT, { ...invoiceForm, status: "saved" })
        .then((res) => {
          setIsSaving(false);
          setTimeout(() => {
            navigate("/payment/invoice");
          }, 1500);
          toast.success(res?.data?.message || "Invoice Saved Successfully");
        })
        .catch((err) => {
          setIsSaving(false);
          toast.error(err?.response?.data?.message || "An error occurred");
        });
    } else {
      setIsSaving(false);
      showInvoiceValidator(true);
    }
  };

  /**
 * Handles payment provider selection
 * @function handleRadioChange
 * @param {string} providerId - ID of the payment provider
 * @param {string} providerName - Name of the payment provider
 */
  const handleRadioChange = (providerId, providerName) => {
    const isCurrentlySelected = invoiceForm?.provider_id === providerId;

    if (isCurrentlySelected) {
    // Unselect if currently selected
      setCreateInvoiceForm((prevForm) => {
        const newForm = { ...prevForm };
        delete newForm?.provider_id;

        return newForm;
      });
      setCurrency([]);
      setIsgettingCurrency(false);
    } else {
    // Select new provider
      setCreateInvoiceForm((prevForm) => ({
        ...prevForm,
        provider_id: providerId
      }));
      setIsgettingCurrency(true);
      httprequest.get(`${INTEGRATIONS}/${providerName}/currencies`).then((res) => {
        setCurrency(res?.data?.data);
        setIsgettingCurrency(false);
      });
    }
  };

  /**
 * Handles currency selection change
 * @function handleCurrencyChange
 * @param {Object} e - Change event
 */
  const handleCurrencyChange = (e) => {
    const curr = e.target.value;

    setCreateInvoiceForm({
      ...invoiceForm,
      currency: curr
      // payment_method: [
      //   ...invoiceForm.payment_method.map((method) => ({
      //     ...method,
      //     currency: curr
      //   }))
      // ]
    });
  };

  /**
   * Get All Terms
   * @param {*} Session_ID
   */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
   * Get All Payment
   */
  const getAllPaymentMethod = () => {
    httprequest
      .get(SCH_INTEGRATION)
      .then((res) => {
        setPaymentIntegration(res?.data?.data?.filter((int) => int?.category?.toLowerCase() === "payment"));
      });
    // .catch(() => {});
  };

  /**
   * getAllInvoiceItem
   */
  const getAllInvoiceItem = () => {
    httprequest
      .get(SCH_ITEM)
      .then((res) => {
        setInvoiceItem(res?.data?.data);
      });
  };

  /**
   * Handle Get All Session
   */
  const getAllStudents = async () => {
    try {
      const res = await httprequest.get(ALL_STUDENT);
      setAllStudent(res?.data?.data?.map((a_student) => ({
        value: a_student?.student?.id,
        label: `${a_student?.student?.last_name} ${a_student?.student?.first_name}`
      })));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
   * Get all classes as a school admin
   */
  const getAllAdminClasses = () => {
    httprequest
      .get(ADMIN_CLASS_ENDPOINT)
      .then((res) => {
        setClassData(res?.data?.data);
      }).catch(() => {});
  };
  /**
   * Handle Get All Session
   *
   */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * Adds a new item row to the invoice
 * @function addItemRow
 */
  const addItemRow = () => {
    const newRow = { item_id: "", amount: "" };

    // Update rows
    const updatedRows = [...rows, newRow];
    setRows(updatedRows);

    // This one updates invoiceForm with the latest invoice_items
    setCreateInvoiceForm((prevForm) => ({
      ...prevForm,
      invoice_items: updatedRows
    }));
  };

  /**
 * Handles changes to invoice item fields
 * @function handleChange
 * @param {Object} e - Change event
 * @param {number} index - Index of the item being edited
 */
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedRows = [...rows];
    updatedRows[index][name] = value;
    setRows(updatedRows);
    // This one updates invoiceForm with the latest invoice_items
    setCreateInvoiceForm((prevForm) => ({
      ...prevForm,
      invoice_items: updatedRows
    }));
  };

  /**
 * Deletes an item from the invoice
 * @function handleDelete
 * @param {number} index - Index of the item to delete
 */
  const handleDelete = (index) => {
    // Remove the selected row
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);

    // This one updates invoiceForm with the latest invoice_items
    setCreateInvoiceForm((prevForm) => ({
      ...prevForm,
      invoice_items: updatedRows
    }));
  };

  /**
   * Find Active Term in an Current Session
   */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
 * Handles term selection change
 * @function handleTermChange
 * @param {Object} event - Change event
 */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  /**
 * Handles term selection change
 * @function handleTermChange
 * @param {Object} event - Change event
 */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    setCreateInvoiceForm({ ...invoiceForm, term_id: selectedTermId });
  };

  const removeDiscount = () => {
    setSelectedDiscount(null);
    setCreateInvoiceForm(prevState => {
      const updatedState = { ...prevState };
      delete updatedState?.discount_id;

      return updatedState;
    });
  };
  /**
 * Handles general invoice input changes
 * @function handleInvoiceInputChange
 * @param {Object} e - Change event
 */
  const handleInvoiceInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "discount_id" && value) {
      const discount = discountItems.find(d => d.id === value);
      if (discount) {
        setSelectedDiscount(discount);
        setCreateInvoiceForm(prevState => ({
          ...prevState,
          discount_id: value
        }));
        handleDiscountModal();
      }
    } else {
    // Forother input changes
      setCreateInvoiceForm(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  /**
 * Handles structure type change
 * @function handleTypeChange
 * @param {Object} e - Change event
 */
  const handleTypeChange = (e) => {
    const type = e.target.value;

    setStructureType(type);
    setCreateInvoiceForm({ ...invoiceForm, structure_type: type });
  };

  /**
 * Fetches subjects for selected classes
 * @function getSubjectsForClasses
 * @async
 * @param {Array} classValues - Array of selected classes
 */
  const getSubjectsForClasses = async (classValues) => {
    try {
      // Start with existing subjects in a temporary array
      const newSubjects = [...allClassSubject];

      // Loop through each selected class to fetch subjects
      for (const { id: classId, name: className } of classValues) {
        const res = await httprequest.get(`${CLASS_SUBJECT}${classId}`);
        const classSubjects = res?.data?.data;

        // Append class name to each subject for display
        const subjectsWithClassName = classSubjects.map((subject) => ({
          ...subject,
          displayName: `${subject.subject_name} | ${className}`
        }));

        // This adds only unique subjects from this class to the newSubjects array
        subjectsWithClassName.forEach((newSub) => {
          if (!newSubjects.some((sub) => sub?.subject_id === newSub?.subject_id)) {
            newSubjects.push(newSub);
          }
        });
      }

      // Update state with the accumulated unique subjects
      setAllClassSubject(newSubjects);
    } catch (err) {
      toast.error(err?.response?.data);
    }
  };

  /**
 * Handles multiple class selection change
 * @function handleMultipleClassChange
 * @async
 * @param {Array} selectedOptions - Array of selected class options
 */
  const handleMultipleClassChange = async (selectedOptions) => {
    // Extract selected class ids as strings
    const selectedValues = selectedOptions.map((option) => option?.id);

    // Fetch and update subjects for all selected classes
    setCreateInvoiceForm({ ...invoiceForm, class_id: selectedValues });
  };

  /**
 * Handles multiple class selection change
 * @function handleSingleStudentChange
 * @async
 * @param {Array} selectedOption - Array of selected class options
 */
  const handleSingleStudentChange = (selectedOption) => {
    setCreateInvoiceForm({ ...invoiceForm, student_id: selectedOption?.value || "" });
  };

  /**
 * Handles multiple class selection change
 * @function handleMultipleAccessChange
 * @async
 * @param {Array} selectedOptions - Array of selected class options
 */
  const handleMultipleAccessChange = async (selectedOptions) => {
    const passedValues = selectedOptions.map((option) => (option?.id));
    // Extract selected class ids and names
    const selectedValues = selectedOptions.map((option) => ({
      id: option?.id,
      name: option?.class_name
    }));

    // Fetch and update subjects for all selected classes
    getSubjectsForClasses(selectedValues);
    setCreateInvoiceForm({ ...invoiceForm, class_id: passedValues });
  };

  /**
   * /**
 * Initial data loading on component mount
 * @effect
 */
  useEffect(() => {
    getAllSessions();
    getAllTerms();
    getAllAdminClasses();
    getAllStudents();
    getAllInvoiceItem();
    getAllPaymentMethod();
    getAllDiscounts();
  }, []);

  /**
 * Updates term when active term changes
 * @effect
 * @listens active_term_session
 */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
      setCreateInvoiceForm({ ...invoiceForm, term_id: active_term_session?.id });
    }
  }, [active_term_session]);

  /**
 * Fetches terms when active session changes
 * @effect
 * @listens activeSession
 */
  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb link_one="/payment/overview" link_one_name="Payments" active="Create Invoice" description="Create student payment invoices." />
          </div>
        </div>
        <div className="page-content padding-equal">
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup
                label="Invoice Name"
                margin="normal"
                inputType="text"
                inputName="invoice_name"
                placeHolder="Enter Name"
                onChange={handleInvoiceInputChange}
                required
              />
              {invoiceValidator.message("Invoice Name", invoiceForm?.invoice_name, "required")}
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              {activeSession?.id && (
                <SelectGroup
                  label="Session"
                  children={
                    <select
                      defaultValue={activeSession?.id}
                      onChange={handleSessionChange}
                      name="session"
                    >
                      <option value="">---Select---</option>
                      {allSessions?.map((sesh) => {
                        return (
                          <option key={sesh?.id} value={sesh?.id}>
                            {sesh?.session}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              )}
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              {active_term_session?.id && (
                <SelectGroup
                  label="Term"
                  children={
                    <select onChange={handleTermChange} name="term_id" value={aselectedTerm}>
                      <option value="">---Select---</option>
                      {selectedSessionTerms?.map((data) => {
                        return (
                          <option key={data?.id} value={data?.id}>
                            {data?.term}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              )}
              {invoiceValidator.message("Term", invoiceForm?.term_id, "required")}
            </Grid>
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <SelectGroup
                label="Structure Type"
                children={
                  <select onChange={handleTypeChange} name="structure_type">
                    <option value="">---Select---</option>
                    {StructureType?.map((structure) => {
                      return (
                        <option key={structure?.key} value={structure?.key}>
                          {structure?.text}
                        </option>
                      );
                    })}
                  </select>
                }
              />
              {invoiceValidator.message("Structure Type", invoiceForm?.structure_type, "required")}
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              {structureType === "class" ? (
                <div className="multiple-select">
                  <p>Class</p>
                  <Select isMulti name="class_id"
                    closeMenuOnSelect={false}
                    options={classData}
                    onChange={handleMultipleClassChange}
                    getOptionLabel={(option) => option.class_name}
                    getOptionValue={(option) => option.id}
                  />
                  {invoiceValidator.message("Class", invoiceForm?.class_id > 0, "required")}
                </div>
              ) : structureType === "student" ? (
                <div className="multiple-select">
                  <p>Student</p>
                  <Select name="student_id"
                    closeMenuOnSelect={true}
                    options={allstudent}
                    onChange={handleSingleStudentChange}
                    getOptionLabel={(option) => option?.label}
                    getOptionValue={(option) => option?.value}
                  />
                  {invoiceValidator.message("Student", invoiceForm?.student_id, "required")}
                </div>
                // <SelectGroup
                //   label="Student"
                //   children={
                //     <select onChange={handleInvoiceInputChange} name="student_id">
                //       <option value="">---Select---</option>
                //       {allstudent?.map((data) => {
                //         return (
                //           <option key={data?.student?.id} value={data?.student?.id}>
                //             {`${data?.student?.last_name} ${data?.student?.frst_name}`}
                //           </option>
                //         );
                //       })}
                //     </select>
                //   }
                // />
              ) : structureType === "subject" ? (
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="multiple-select">
                      <p>Class</p>
                      <Select isMulti name="class_id"
                        closeMenuOnSelect={false}
                        options={classData}
                        onChange={handleMultipleAccessChange}
                        getOptionLabel={(option) => option.class_name}
                        getOptionValue={(option) => option.id}
                      />
                      {invoiceValidator.message("Class", invoiceForm?.class_id > 0, "required")}
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    {/* <div className="multiple-select">
                      <p>Select Subject</p>
                      <Select isMulti name="subject_id"
                        closeMenuOnSelect={false}
                        options={allClassSubject}
                        onChange={handleMultipleSubjectChange}
                        getOptionLabel={(option) => option?.displayName}
                        getOptionValue={(option) => option?.subject_id}
                      />
                    </div> */}
                    <SelectGroup
                      label="Subject"
                      children={
                        <select onChange={handleInvoiceInputChange} name="subject_id">
                          <option value="">---Select---</option>
                          {allClassSubject?.map((data) => {
                            return (
                              <option key={data?.subject_id} value={data?.subject_id}>
                                {data?.displayName}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {invoiceValidator.message("Subject", invoiceForm?.subject_id, "required")}
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <label className={classes.enterque}>Online Payment Method</label>
              <Grid container spacing={1} sx={{ marginTop: "2px" }}>
                {paymentIntegration?.length > 0 ? (
                  paymentIntegration.map((item) => (
                    <Grid item lg={4} md={4} sm={6} xs={12} key={item.id}>
                      <div onClick={() => handleRadioChange(item?.id, item?.provider)} className="soft-border flex justify-content-between gap-24 text-align-left">
                        <div>
                          <img
                            height="23px"
                            src={
                              item?.provider?.toUpperCase() === "PAYSTACK" ? PayStack :
                                item?.provider?.toUpperCase() === "PAYPAL" ? PayPal :
                                  item?.provider?.toUpperCase() === "STRIPE" ? Stripe :
                                    item?.provider?.toUpperCase() === "FLUTTERWAVE" ? Flutterwave :
                                      item?.provider?.toUpperCase() === "REMITA" ? Remita :
                                        null
                            }
                            alt="Payment Provider"
                          />
                          <p className="no-margin-block">{item?.provider}</p>
                        </div>
                        <input disabled={isGettingCurrency} type="checkbox" checked={invoiceForm?.provider_id === item?.id} />
                      </div>
                    </Grid>
                  ))
                ) : (
                  <div className={classes.plsintegrate}>
                    <p className="cursor-pointer no-margin-block " onClick={() => navigate("/payment-settings")}>Please Add a Payment Integration <ArrowOutwardIcon /></p>
                  </div>
                )}
                <Grid item xs={12}>
                  <div className="text-align-left">
                    {invoiceValidator.message(
                      "Payment Method",
                      invoiceForm?.provider_id || (invoiceForm?.bank_accounts && invoiceForm?.bank_accounts.length > 0 ? "has_bank_accounts" : null),
                      "required"
                    )}
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <label className={classes.enterque}>Offline Payment Method</label>
              <Grid container spacing={1} sx={{ marginTop: "2px" }}>
                {profile?.bank_details?.length > 0 ? (
                  profile?.bank_details?.map((item) => (
                    <Grid item lg={4} md={4} sm={6} xs={12} key={item?.id}>
                      <div onClick={() => {
                        // Create a synthetic event objectis create
                        const syntheticEvent = {
                          target: {
                            type: "checkbox",
                            checked: !invoiceForm?.bank_accounts?.includes(item?.id)
                          }
                        };
                        handleBankAccountChange(syntheticEvent, item?.id);
                      }} className={classes.bankCard}
                      >
                        <div className={classes.bankCardContent}>
                          <div className={classes.bankHeader}>
                            <Icon icon="guidance:bank" width="24" height="24" />
                            <p className={classes.bankName}>{item?.bank_name?.toUpperCase()}</p>
                          </div>
                          {item?.is_primary && <span className={classes.primaryBadge}>Primary</span>}
                        </div>
                        <input
                          type="checkbox"
                          checked={invoiceForm?.bank_accounts?.includes(item?.id) || false}
                        />
                      </div>
                    </Grid>
                  ))
                ) : (
                  <div className={classes.plsintegrate}>
                    <p className="cursor-pointer no-margin-block">
                      No Bank Account added
                    </p>
                  </div>
                )}
                <Grid item xs={12}>
                  <div className="text-align-left">
                    {invoiceValidator.message(
                      "Payment Method",
                      invoiceForm?.provider_id || (invoiceForm?.bank_accounts && invoiceForm?.bank_accounts.length > 0 ? "has_bank_accounts" : null),
                      "required"
                    )}
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid item lg={12} md={12} sm={12} xs={12}>
              <SelectGroup
                label="Payment Currency"
                children={
                  (() => {
                    // Merge both data sources and remove duplicates
                    const mergedData = [];
                    const seenCurrencies = new Set();

                    // Process currency array (online payments)
                    if (currency?.length) {
                      currency?.forEach(item => {
                        const value = item?.key || item?.currency || item;
                        const label = item?.key || item?.currency || item;

                        if (value && !seenCurrencies?.has(value)) {
                          seenCurrencies?.add(value);
                          mergedData.push({
                            value,
                            label,
                            source: "online"
                          });
                        }
                      });
                    }

                    // Process bank details (profile payments)
                    if (profile?.bank_details?.length) {
                      profile?.bank_details?.forEach(item => {
                        const value = item?.key || item?.currency || item;
                        const label = item?.key || item?.currency || item;

                        if (value && !seenCurrencies.has(value)) {
                          seenCurrencies.add(value);
                          mergedData.push({
                            value,
                            label,
                            source: "bank"
                          });
                        }
                      });
                    }

                    const isOnlinePayment = currency?.length;
                    const selectName = isOnlinePayment ? "structure_type" : "currency";
                    const handleChange = isOnlinePayment ? handleCurrencyChange : handleInvoiceInputChange;
                    const isLoading = isOnlinePayment && isGettingCurrency;

                    return (
                      <select onChange={handleChange} name={selectName}>
                        <option value="">
                          {isLoading ? "Please wait..." : "---Select---"}
                        </option>
                        {mergedData?.map((item, index) => (
                          <option key={`${item?.value}-${index}`} value={item?.value}>
                            {item?.label} {item?.source === "online" ? "(Online)" : "(Bank)"}
                          </option>
                        ))}
                      </select>
                    );
                  })()
                }
              />
              {invoiceValidator.message(
                "Currency",
                invoiceForm?.currency,
                "required"
              )}
            </Grid> */}
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <SelectGroup
                label="Payment Currency"
                children={
                  (() => {
                    // Determine if online payment or bank payment is selected
                    const hasOnlinePayment = invoiceForm?.provider_id;
                    const hasBankPayment = invoiceForm?.bank_accounts?.length > 0;

                    const filteredData = [];
                    const seenCurrencies = new Set();

                    // If online payment is selected, show only online currencies
                    if (hasOnlinePayment) {
                      if (currency?.length) {
                        currency?.forEach(item => {
                          const value = item?.key || item?.currency || item;
                          const label = item?.key || item?.currency || item;

                          if (value && !seenCurrencies?.has(value)) {
                            seenCurrencies?.add(value);
                            filteredData.push({
                              value,
                              label,
                              source: "online"
                            });
                          }
                        });
                      }
                    } else if (hasBankPayment) {
                      if (profile?.bank_details?.length) {
                        profile?.bank_details?.forEach(item => {
                          const value = item?.key || item?.currency || item;
                          const label = item?.key || item?.currency || item;

                          if (value && !seenCurrencies.has(value)) {
                            seenCurrencies.add(value);
                            filteredData.push({
                              value,
                              label,
                              source: "bank"
                            });
                          }
                        });
                      }
                    }

                    const isOnlinePayment = currency?.length;
                    const selectName = isOnlinePayment ? "structure_type" : "currency";
                    const handleChange = isOnlinePayment ? handleCurrencyChange : handleInvoiceInputChange;
                    const isLoading = isOnlinePayment && isGettingCurrency;

                    return (
                      <select value={invoiceForm?.currency || ""} onChange={handleChange} name={selectName}>
                        <option value="">
                          {isLoading ? "Please wait..." : "---Select---"}
                        </option>
                        {filteredData?.map((item, index) => (
                          <option key={`${item?.value}-${index}`} value={item?.value}>
                            {item?.label}
                          </option>
                        ))}
                      </select>
                    );
                  })()
                }
              />
              {invoiceValidator.message(
                "Currency",
                invoiceForm?.currency,
                "required"
              )}
            </Grid>
          </Grid>
          <TableContainer component={Paper} style={{ marginBlock: "20px 30px" }}>
            <Table>
              <TableHead style={{ backgroundColor: "#F9FAFB" }}>
                <TableRow>
                  <TableCell colSpan={4}>Item</TableCell>
                  {/* <TableCell>Payment Method</TableCell> */}
                  <TableCell>Amount</TableCell>
                  {/* <TableCell>Payment Option</TableCell> */}
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ width: "100%" }}>
                <>
                  {invoiceForm?.invoice_items?.map((row, index) => (
                    <TableRow key={index}>
                      {/* Select for Item */}
                      <TableCell colSpan={4}>
                        <SelectGroup
                          children={
                            <select onChange={(e) => handleChange(e, index)} name="item_id">
                              <option value="">---Select---</option>
                              {invoiceItem?.map((data) => {
                                return (
                                  <option key={data?.id} value={data?.id}>
                                    {data?.item}
                                  </option>
                                );
                              })}
                            </select>
                          }
                        />
                        {invoiceValidator.message("Item", invoiceForm?.invoice_items[index]?.item_id, "required")}
                      </TableCell>

                      {/* Input for Amount & Currency */}
                      <TableCell colSpan={1} className="padding-block-413">
                        <InputGroup
                          margin="normal"
                          inputType="text"
                          inputName="amount"
                          placeholder="Amount"
                          onChange={(e) => handleChange(e, index)}
                          style={{ maxWidth: "200px", width: "100%" }}
                        />
                        {invoiceValidator.message("Amount", invoiceForm?.invoice_items[index]?.amount, "required")}
                      </TableCell>

                      {/* Delete Button */}
                      {invoiceForm?.invoice_items?.length > 1 && (
                        <TableCell className="padding-block-413">
                          <button
                            className="table-action-icon delete-icon"
                            onClick={() => handleDelete(index)}
                          >
                            <Icon icon="mingcute:delete-2-line" />
                          </button>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                  <TableRow>
                    {/* Discount Display Row - Only show if discount is applied */}
                    {selectedDiscount && (
                      <TableRow className={classes.discountRow}>
                        <TableCell colSpan={3} className={classes.discountLabel}>
      Discount Added to Invoice
                        </TableCell>
                        <TableCell className={classes.discountValue}>
                          {selectedDiscount?.name} - {selectedDiscount?.value}%
                        </TableCell>
                        <TableCell className={classes.discountActions}>
                          <Icon
                            icon="mdi:delete"
                            width="24"
                            height="24"
                            className={classes.deleteIcon}
                            onClick={removeDiscount}
                          />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableRow>
                  {/* Add Items and Discount */}
                  <TableRow>
                    <TableCell colSpan={5} style={{ textAlign: "center", paddingBlock: "0px" }}>
                      <div className={classes.addItemContainer}>
                        {/* Add Item Button */}
                        <div className={classes.additem} onClick={addItemRow}>
                          <Icon icon="icons8:plus" width="20" height="30" className={classes.icon} />
                          <p>Add item</p>
                        </div>

                        {/* Apply Discount Button */}
                        {(invoiceForm?.structure_type === "student" && !invoiceForm?.discount_id) && (
                          <div className={classes.additem}>
                            <Icon icon="ic:outline-discount" width="20" height="30" className={classes.icon} />
                            <p onClick={handleDiscountModal}>Apply Discount</p>
                          </div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                </>
              </TableBody>
              <TableFooter style={{ backgroundColor: "#F9FAFB" }}>
                <TableRow>
                  <TableCell colSpan={3} style={{ textAlign: "left", fontWeight: "700", fontSize: "14px", padding: "24px" }}>
                        Total
                  </TableCell>
                  <TableCell colSpan={3} style={{ textAlign: "right", fontWeight: "700", fontSize: "18px", padding: "24px" }}>
                    {`${invoiceForm?.currency || ""} ${getFormattedTotal()}`}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextAreaGroup
                label="Description"
                margin="normal"
                inputType="text"
                inputName="description"
                required
                onChange={handleInvoiceInputChange}
              />
              {invoiceValidator.message("Description", invoiceForm?.description, "required")}
            </Grid>
            {/* <Grid item lg={6} md={6} sm={12} xs={12}>
              <SelectGroup
                label="Status"
                children={
                  <select onChange={handleInvoiceInputChange} name="status">
                    <option value="">---Select---</option>
                    {PaymentStatus?.map((data) => {
                      return (
                        <option key={data?.key} value={data?.key}>
                          {data?.text}
                        </option>
                      );
                    })}
                  </select>
                }
              />
              {invoiceValidator.message("Status", invoiceForm?.status, "required")}
            </Grid> */}
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <InputGroup
                label="Invoice Due Date"
                margin="normal"
                inputType="date"
                inputName="due_date"
                inputMin={formattedToday}
                required
                onChange={handleInvoiceInputChange}
              />
              {invoiceValidator.message("Due Date", invoiceForm?.due_date, "required")}
            </Grid>
          </Grid>
          <div className={`${classes.footerbtn} flex gap-10 flex-direction-col-413`}>
            <Button
              variant="deleteOutline"
              buttonSize="full"
              color="btndanger"
              buttonName="Cancel"
              onClick={handleCancelModal}
            />
            <Button
              variant="primaryoutline"
              buttonSize="full"
              color="btnfontprimary"
              buttonName="Save"
              isLoading={isSaving}
              onClick={handleSaveInvoice}
            />
            <Button
              variant="primary"
              buttonSize="full"
              color="btndefault"
              buttonName="Send"
              disabled={isSending}
              isLoading={isSending}
              onClick={handleSendInvoice}
            />
          </div>
        </div>
        <Modal
          title="Add Discount to Invoice"
          subtitle={
            <div>
               Select a discount to be added to your Invoice.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Select Discount"
                    children={
                      <select onChange={handleInvoiceInputChange} name="discount_id">
                        <option value="">{isGettingDiscounts ? "Please wait..." : "--Select--"}</option>
                        {discountItems?.map((discount) => {
                          return (
                            <option key={discount?.id} value={discount?.id}>
                              {discount?.name} - {discount?.value}%
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
              </Grid>
            </>
          }
          modalFooter={<></>}
          isopen={discountModal}
          closeModal={handleDiscountModal}
        />
        {/* Cancel and Go back to Payment Overview */}
        <Modal
          title="Cancel"
          subtitle={
            <div>
            Are you sure you want to cancel ?. All unsaved data will be Lost.
            </div>
          }
          modalContent={<></>}
          modalFooter={
            <>
              <div className="flex gap-10">
                <Button
                  variant="dangeroutline"
                  buttonSize="full"
                  color="btndanger"
                  buttonName="Go Back"
                  onClick={handleCloseCancelModal}
                />
                <Button
                  variant="danger"
                  buttonName="Yes Cancel"
                  buttonSize="full"
                  color="btndefault"
                  onClick={() => navigate("/payment/overview")}
                />
              </div>
            </>
          }
          isopen={cancelModal}
          closeModal={handleCloseCancelModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default CreateInvoice;
